import { useState, useCallback } from 'react';
import { pwp211Api } from '../../../services/pwp211Api';

export function usePWP211Navigation(loadRecord: (id: string) => Promise<null>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState<number>(-1);

  const loadList = useCallback(async () => {
    try {
      const res = await pwp211Api.list(1, 200);
      const ids = res.data.map(r => r.fp120_01);
      setAllIds(ids);
      if (ids.length > 0) {
        setCurrentIdx(0);
        await loadRecord(ids[0]);
      }
    } catch {
      // ignore
    }
  }, [loadRecord]);

  const navTo = useCallback(async (idx: number) => {
    if (idx < 0 || idx >= allIds.length) return;
    setCurrentIdx(idx);
    await loadRecord(allIds[idx]);
  }, [allIds, loadRecord]);

  const navFirst = useCallback(() => navTo(0), [navTo]);
  const navPrev = useCallback(() => navTo(currentIdx - 1), [navTo, currentIdx]);
  const navNext = useCallback(() => navTo(currentIdx + 1), [navTo, currentIdx]);
  const navLast = useCallback(() => navTo(allIds.length - 1), [navTo, allIds.length]);

  return { allIds, currentIdx, loadList, navTo, navFirst, navPrev, navNext, navLast };
}
